import { gql } from "@apollo/client";

export const CONNECT_INVOICE_UPLOAD_UNIT_TO_CLIENT = gql`
  mutation connectInvoiceUploadUnitToClientIdentifier(
    $input: ConnectUploadUnitToClientIdentifierInput!
  ) {
    documentHandler {
      connectInvoiceUploadUnitToClientIdentifier(input: $input) {
        success
      }
    }
  }
`;
